export const REACT_APP_RATEMATCH_URL = process.env.REACT_APP_RATEMATCH_URL;
export const REACT_APP_ICONSEO_URL = process.env.REACT_APP_ICONSEO_URL;
export const REACT_APP_ICONCMS_URL = process.env.REACT_APP_ICONCMS_URL;
export const REACT_APP_PUSHTECH_URL = process.env.REACT_APP_PUSHTECH_URL;
